
type Props = {
    onClick: (label: TCBarItem) => void,
    selected: TCBarItem
}
export type TCBarItem = 'Education Levels' | 'Exams'

const ConfigTopBar = ({ selected, onClick }: Props) => {
    const items: TCBarItem[] = ['Education Levels', 'Exams']

    return (
        <div className="flex items-center p-1 bg-gray-100/50 rounded-xl w-fit border border-gray-200 shadow-sm" >
            {items.map((label) => (
                <button
                    key={label}
                    onClick={() => onClick(label)}
                    className={`
                        px-6 py-2 rounded-lg text-sm font-medium transition-all duration-200
                        ${selected === label 
                            ? 'bg-white text-primary shadow-sm' 
                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-200/50'}
                    `}
                >
                    {label}
                </button>
            ))}
        </div>
    )
}

export default ConfigTopBar